import React from "react";
import { Route, Switch } from "react-router-dom";
// No logged
import LoginScreen from "../screens/LoginScreen";
import ResetPasswordPage from "../screens/ResetPasswordPage";
import SSOPage from "../screens/SSOPage";
// server manteinance
import ServerMissing from "Components/ServerMissing";

export default function (props) {
  return (
    <Switch>
      <Route path="/manteinance" component={ServerMissing} />
      <Route path="/users/:userCode/reset_password" component={ResetPasswordPage} />
      <Route path="/login" component={LoginScreen} />
      <Route path="/sso/:token" component={SSOPage} />
    </Switch>
  );
}
